/**
 * Destination Search Actions
 *
 * @return {void}
 */
const STSharedTracking = window.STSharedTracking || {};
const dayjs = require('dayjs'); // eslint-disable-line no-undef

//include $
// const $ = require('jquery'); // eslint-disable-line no-undef
const $ = window.jQuery;
/**
 * Destination Search Init
 *
 * Note: used by smartertravel.com with the `Hotel Call to Action - Property` shortcode
 *
 * @returns {void}
 */
const init = () => {
	/**
	 * Datepicker
	 *
	 * @returns {void}
	 */
	const datePickerActivate = () => {
		const friday = 5;
		const weeksInTheFuture = 15;
		const daysInTheFuture = parseInt(weeksInTheFuture * 7, 10);
		const nightStays = 3;
		const startDate = new Date();
		const endDate = new Date();

		// If current day is Friday, check in on next friday in 15 weeks
		if (startDate.getDay() === friday) {
			startDate.setDate(startDate.getDate() + daysInTheFuture);
			endDate.setDate(endDate.getDate() + daysInTheFuture + nightStays);
			// Else check in on upcoming Friday
		} else {
			startDate.setDate(startDate.getDate() + daysInTheFuture + ((friday + 7 - startDate.getDay()) % 7));
			endDate.setDate(endDate.getDate() + daysInTheFuture + nightStays + ((friday + 7 - endDate.getDay()) % 7));
		}

		const updatedDate = `${dayjs(startDate).format('MMM DD, YYYY')} to ${dayjs(endDate).format('MMM DD, YYYY')}`;

		/* eslint-disable object-shorthand */
		/**
		 * Activate picker
		 *
		 * @param {string} picker picker id
		 * @return {void}
		 */
		const activatePicker = (picker) => {
			$(`#${picker}`)
				.dateRangePicker({
					format: 'MMM D, YYYY',
					minDays: 2,
					maxDays: 28,
					autoClose: true,
					stickyMonths: true,
					startDate: new Date(),
					customArrowPrevSymbol: '←',
					customArrowNextSymbol: '→',
					showTopbar: false,
					setValue: function (s) {
						if (
							(!$(this).attr('readonly') || $(this).attr('readonly')) &&
							!$(this).is(':disabled') &&
							s !== $(this).val()
						) {
							$(this).val(s).trigger('change');
						}
					},
					hoveringTooltip: function (days) {
						const s = days > 2 ? 's' : '';
						return days > 1 ? days - 1 + ' night' + s : '';
					},
				})
				.attr('readonly', 'readonly');
		};

		/**
		 * Activate CTA datepickers - multiple
		 *
		 * @returns {void}
		 */
		const ctaDatePickersActivate = () => {
			const ctaDatePickers = document.querySelectorAll('.product-book-modal-daterange');

			ctaDatePickers.forEach((element, index) => {
				element.id = `product-book-modal-daterange-${index}`;

				// use default "updatedDate" daterange if user doesn't have a cookie already created
				if (-1 === document.cookie.indexOf('js_check_in_out_date')) {
					element.value = updatedDate;
				}

				activatePicker(`product-book-modal-daterange-${index}`);
			});
		};

		ctaDatePickersActivate();

		// Set Cookie On Date Change.
		// Pulled this code from Jetsetter.com original JS
		$(document).on('change', '.destination-datepick', function () {
			STSharedTracking.setCookie('js_check_in_out_date', $(this).val());
		});
	};

	/**
	 * Destination Search Actions
	 *
	 * @returns {void}
	 */
	const destinationSearchActions = () => {
		datePickerActivate();
	};

	destinationSearchActions();
};

export default { init };
